/**
 * 承認待ちの札が「何段目を待っているか」 (多段階承認、 AC-BIN-095)。
 *
 * - `current` = 今待っている段 = 完了した段数 + 1
 * - `total` = 段の総数 (承認申請時の snapshot)
 */
export type ApprovalStageProgress = {
  current: number
  total: number
}

type Input = {
  /** 段の総数。 未設定 (= 1 段扱い、 proto の optional) なら undefined。 */
  approvalStageCount: number | undefined
  /** 完了した段数。 */
  approvedStageCount: number
  /** 札が承認待ち (承認軸 PENDING) か。 */
  isPending: boolean
}

/**
 * 「{N}/{M}段階」 を出す札の進捗を返す。 出さない札 (承認待ちでない / 段数 1 / 段数未設定 /
 * 完了段数が総数以上で矛盾している) は undefined。 一覧 ・ 詳細 ・ 承認確認の表示可否と
 * N / M の算出をここに集約する。
 */
export function resolveApprovalStageProgress({
  approvalStageCount,
  approvedStageCount,
  isPending,
}: Input): ApprovalStageProgress | undefined {
  if (!isPending) return undefined
  if (approvalStageCount === undefined || approvalStageCount < 2) {
    return undefined
  }
  const current = approvedStageCount + 1
  if (current > approvalStageCount) return undefined
  return { current, total: approvalStageCount }
}
